export default __webpack_public_path__ + "static/media/eth-change-arrow-zero.1d8a169b.svg";